export {
  default as StyledRedemptionButton,
  ActionLink as StyledSignUpToRedeemLink,
} from 'components/action-button';
